import React from 'react';
import { FieldLabel } from '../components/FieldLabel';
import './AssignmentActionsPanel.css';

const AssignmentActionsPanel = ({
  appointment,
  onAssignTechService,
  onAssignTechnician,
  onCancelTechService,
  onCancelTechnician,
  isAdmin = false,
}) => {

  if (!appointment || !isAdmin) {
    return null;
  }

  const currentStatus = appointment.durum || '';

  // Durum badge renkleri
  const getStatusColor = (status) => {
    const colors = {
      'Randevu Bekleniyor': '#f59e0b',
      'Randevu Tarihi Bekleniyor': '#3b82f6',
      'İşlemde': '#10b981',
      'Randevu Tamamlandı': '#22c55e',
      'Randevu İptal Edildi': '#ef4444',
    };
    return colors[status] || '#6b7280';
  };

  // Duruma göre yapılabilir işlemler (Randevu Tarihi Bekleniyor -> İşlemde -> Tamamlandı / Randevu İptal Edildi)
  // Not: Randevu Bekleniyor servis kaydı durumudur, randevu durumu değil. Geriye dönük uyumluluk için case eklendi.
  const getAvailableActions = () => {
    const actions = [];

    switch (currentStatus) {
      case 'Randevu Tarihi Bekleniyor':
      case 'Randevu Bekleniyor':
        // Teknisyen Ata + Teknik Servis İptal + Teknisyen İptal
        actions.push({
          id: 'assign-technician',
          label: 'Teknisyen Ata',
          icon: 'fa-user-plus',
          color: 'primary',
          onClick: onAssignTechnician,
        });
        actions.push({
          id: 'cancel-tech-service',
          label: 'Teknik Servis İptal',
          icon: 'fa-times-circle',
          color: 'danger',
          onClick: onCancelTechService,
        });
        actions.push({
          id: 'cancel-technician',
          label: 'Teknisyen İptal',
          icon: 'fa-user-times',
          color: 'warning',
          onClick: onCancelTechnician,
        });
        break;

      case 'İşlemde':
      case 'Randevu Tamamlandı':
      case 'Randevu İptal Edildi':
        // Randevu sonrası durumlar - işlem yapılamaz
        break;

      default:
        break;
    }

    return actions;
  };

  const availableActions = getAvailableActions();

  return (
    <div className="assignment-actions-panel">
      <div className="panel-header">
        <div className="panel-title">
          <i className="fas fa-tasks"></i>
          <h3>Atama İşlemleri</h3>
        </div>
        <div className="current-status-badge" style={{ backgroundColor: getStatusColor(currentStatus) }}>
          <i className="fas fa-info-circle"></i>
          <span>{currentStatus}</span>
        </div>
      </div>

      <div className="panel-content">
        {/* Mevcut Durum Bilgisi */}
        <div className="status-info">
          <div className="info-row">
            <FieldLabel className="info-label" as="span">Mevcut Durum:</FieldLabel>
            <span className="info-value">{currentStatus}</span>
          </div>
          {appointment.randevuTarihi && (
            <div className="info-row">
              <FieldLabel className="info-label" as="span">Randevu Tarihi:</FieldLabel>
              <span className="info-value">
                {new Date(appointment.randevuTarihi).toLocaleDateString('tr-TR')} - {appointment.randevuSaati || ''}
              </span>
            </div>
          )}
          {(appointment.teknikServisAdi || appointment.teknikServis || appointment.teknikServisId) && (
            <div className="info-row">
              <FieldLabel className="info-label" as="span">Teknik Servis:</FieldLabel>
              <span className="info-value">
                {(() => {
                  // Direkt field (en yaygın)
                  if (appointment.teknikServisAdi) {
                    return appointment.teknikServisAdi;
                  }
                  // Backend'den gelen teknikServis bilgisi
                  if (appointment.teknikServis?.teknikServisAdi) {
                    return appointment.teknikServis.teknikServisAdi;
                  }
                  if (appointment.teknikServis?.ad || appointment.teknikServis?.name) {
                    return appointment.teknikServis.ad || appointment.teknikServis.name;
                  }
                  // Populate edilmiş teknikServisId
                  if (appointment.teknikServisId?.ad || appointment.teknikServisId?.name) {
                    return appointment.teknikServisId.ad || appointment.teknikServisId.name;
                  }
                  return '---';
                })()}
              </span>
            </div>
          )}
          {(appointment.teknisyenAdi || appointment.teknisyen?.teknisyenAdi || appointment.teknisyen?.adi || appointment.teknisyen?.ad || appointment.teknisyen || appointment.teknisyenId) && (
            <div className="info-row">
              <FieldLabel className="info-label" as="span">Teknisyen:</FieldLabel>
              <span className="info-value">
                {(() => {
                  // Format 1: Backend controller'dan gelen (teknisyenAdi birleşik)
                  if (appointment.teknisyen?.teknisyenAdi) {
                    return appointment.teknisyen.teknisyenAdi;
                  }
                  // Format 2: Direkt field
                  if (appointment.teknisyenAdi) {
                    return appointment.teknisyenAdi;
                  }
                  // Format 3: Tüm olası field kombinasyonları (getTechnicianName ile aynı)
                  if (appointment.teknisyen) {
                    const ad = appointment.teknisyen.ad || appointment.teknisyen.name || appointment.teknisyen.adi || '';
                    const soyad = appointment.teknisyen.soyad || appointment.teknisyen.surname || appointment.teknisyen.soyadi || '';
                    const fullName = `${ad} ${soyad}`.trim();
                    if (fullName) return fullName;
                  }
                  // Format 4: Populate edilmiş teknisyenId
                  if (appointment.teknisyenId) {
                    const ad = appointment.teknisyenId.ad || appointment.teknisyenId.name || appointment.teknisyenId.adi || '';
                    const soyad = appointment.teknisyenId.soyad || appointment.teknisyenId.surname || appointment.teknisyenId.soyadi || '';
                    const fullName = `${ad} ${soyad}`.trim();
                    if (fullName) return fullName;
                  }
                  // FALLBACK: Atama geçmişinden al (ESKİ RANDEVULAR İÇİN)
                  if (appointment.atamaGecmisi && Array.isArray(appointment.atamaGecmisi)) {
                    const technicianAssignment = appointment.atamaGecmisi.find(
                      h => (h.atamaTipi === 'Teknisyen' || h.atamaTipi === 'Teknisyen Ataması') 
                           && h.durum === 'Atandı'
                    );
                    if (technicianAssignment?.atananAdi) {
                      return technicianAssignment.atananAdi;
                    }
                  }
                  return '---';
                })()}
              </span>
            </div>
          )}
        </div>

        {/* İşlem Butonları */}
        {availableActions.length > 0 ? (
          <div className="actions-section">
            <h4>Yapılabilir İşlemler</h4>
            <div className="action-buttons">
              {availableActions.map((action) => (
                <button
                  key={action.id}
                  type="button"
                  className={`action-btn ${action.color}`}
                  onClick={action.onClick}
                >
                  <i className={`fas ${action.icon}`}></i>
                  <span>{action.label}</span>
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className="info-message">
            <i className="fas fa-info-circle"></i>
            <p>Bu durum için yapılabilir işlem bulunmamaktadır.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignmentActionsPanel;
